import React, { useEffect } from 'react';
import { Form, Input, Select, Modal, DatePicker } from 'antd';

const { Option } = Select;
const { TextArea } = Input;

const TenantForm = ({ visible, onCancel, onSubmit, initialValues, title, industries, factories }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      if (initialValues) {
        console.log('Initial Values:', initialValues);
        console.log('Note value:', initialValues.Note);
        
        const factoryIDs = initialValues.Contracts 
          ? initialValues.Contracts.map(contract => contract.FactoryID)
          : initialValues.Factories || [];
        
        console.log('Factory IDs:', factoryIDs);
          
        form.setFieldsValue({
          ...initialValues,
          Factories: factoryIDs,
          Note: initialValues.Note || initialValues.note || '',
          Status: initialValues.Status !== undefined ? initialValues.Status : true
        });
      } else {
        form.resetFields();
        form.setFieldsValue({
          Status: true
        });
      }
    }
  }, [visible, initialValues, form]);

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleSubmit = () => {
    form.validateFields().then(values => {
      onSubmit(values);
      form.resetFields();
    });
  };

  return (
    <Modal
      visible={visible}
      title={title}
      onCancel={handleCancel}
      onOk={handleSubmit}
      width={800}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="TenantID"
          label="Mã khách hàng"
          rules={[{ required: true, message: 'Vui lòng nhập mã khách hàng!' }]}
        >
          <Input placeholder="Nhập mã khách hàng" />
        </Form.Item>

        <Form.Item
          name="TenantName"
          label="Tên khách hàng"
          rules={[{ required: true, message: 'Vui lòng nhập tên khách hàng!' }]}
        >
          <Input placeholder="Nhập tên khách hàng" />
        </Form.Item>

        <Form.Item
          name="Address"
          label="Quốc gia"
          rules={[{ required: true, message: 'Vui lòng nhập quốc gia!' }]}
        >
          <Input placeholder="Nhập quốc gia" />
        </Form.Item>

        <Form.Item
          name="Email"
          label="Email (ngăn cách bởi dấu phẩy nếu có nhiều email)"
          rules={[
            { required: true, message: 'Vui lòng nhập email!' },
            {
              validator: (_, value) => {
                if (!value) return Promise.reject();
                const emails = value.split(',').map(email => email.trim());
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const invalidEmails = emails.filter(email => !emailRegex.test(email));
                if (invalidEmails.length > 0) {
                  return Promise.reject(new Error('Một hoặc nhiều email không hợp lệ!'));
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <Input.TextArea 
            placeholder="Nhập email (ngăn cách bởi dấu phẩy nếu có nhiều email)"
            autoSize={{ minRows: 1, maxRows: 3 }}
          />
        </Form.Item>

        <Form.Item
          name="Phone"
          label="Số điện thoại"
          rules={[
            { required: true, message: 'Vui lòng nhập số điện thoại!' },
            { pattern: /^[0-9]{10,11}$/, message: 'Số điện thoại không hợp lệ!' }
          ]}
        >
          <Input placeholder="Nhập số điện thoại" />
        </Form.Item>

        <Form.Item
          name="PaymentDueDate"
          label="Hạn thanh toán (ngày)"
          rules={[{ required: true, message: 'Vui lòng chọn hạn thanh toán!' }]}
        >
          <Input placeholder="Nhập hạn thanh toán (ngày)" type="number" />
        </Form.Item>

        <Form.Item
          name="Password"
          label="Mật khẩu"
          rules={[
            { 
              message: 'Vui lòng nhập mật khẩu!' 
            },
            { 
              min: 6, 
              message: 'Mật khẩu phải có ít nhất 6 ký tự!' 
            }
          ]}
        >
          <Input.Password 
            placeholder="Nhập mật khẩu mới" 
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item
          name="BusinessType"
          label="Ngành nghề"
          rules={[{ required: true, message: 'Vui lòng chọn ngành nghề!' }]}
        >
          <Select placeholder="Chọn ngành nghề">
            {industries.map(industry => (
              <Option key={industry.IndustryID} value={industry.IndustryID}>
                {industry.IndustryName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="Status"
          label="Trạng thái"
          rules={[{ required: true, message: 'Vui lòng chọn trạng thái!' }]}
        >
          <Select placeholder="Chọn trạng thái">
            <Option value={true}>Hoạt động</Option>
            <Option value={false}>Ngừng hoạt động</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="Factories"
          label="Nhà xưởng đang thuê"
        >
          <Select
            placeholder="Chọn nhà xưởng"
            optionFilterProp="children"
          >
            {factories.filter(f => {
              const isRentedByThisTenant = initialValues?.Contracts?.some(
                contract => contract.FactoryID === f.FactoryID
              );
              return f.Status !== 'Đã cho thuê' || isRentedByThisTenant;
            }).map(factory => (
              <Option key={factory.FactoryID} value={factory.FactoryID}>
                {factory.FactoryID} - {factory.FactoryName} ({factory.Area}m²)
              </Option>
            ))}
          </Select>
        </Form.Item>

            
        <Form.Item
          name="Note"
          label="Ghi chú"
        >
          <TextArea rows={4} placeholder="Nhập ghi chú" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TenantForm; 